<div class="widget-title">{{ regionName }} Region Rank</div>
<div #regionRankContainer class="col-12 regionRankContainer">
    <div id="table-container">

    </div>
    <div *ngIf="noData" class="noData">No Data Available</div>
</div>